import { forwardRef } from 'react'
import {
  MaskedInputField,
  MaskedInputFieldProps,
  TextInputField,
  TextInputFieldProps,
} from 'utoniq-ui'

import { useTranslation } from '@/core'
import { CellFrame } from '@/core/architecture'

export const TextInputCell = forwardRef(
  ({ titleProps, ...props }: Omit<TextInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('consoleEventCollectionReceiveTimeEdit')
    return (
      <CellFrame>
        <TextInputField
          titleProps={{ ...titleProps, variant: 'h5', color: 'text.primary' }}
          ref={ref}
          {...props}
          t={t}
        />
      </CellFrame>
    )
  }
)

export const MaskedInputCell = forwardRef(
  (
    {
      titleProps,
      textFieldProps,
      error,
      ...props
    }: Omit<MaskedInputFieldProps, 't'>,
    ref
  ) => {
    const { t } = useTranslation('consoleEventCollectionReceiveTimeEdit')
    return (
      <CellFrame>
        <MaskedInputField
          {...props}
          titleProps={{
            variant: 'h5',
            color: 'text.primary',
            sx: { display: 'none' },
            ...titleProps,
          }}
          textFieldProps={{ ...textFieldProps, sx: { mt: 0, mb: 0 } }}
          ref={ref}
          t={t}
          error={error}
          placeholder="--:--"
        />
      </CellFrame>
    )
  }
)
